import { NgModule } from '@angular/core';

import { TwcModule } from '@topcon/twc-angular';

import { AutoFocusDirective } from './auto-focus';
import { DebounceKeyUpDirective } from './debounce-keyup/debounce-keyup.directive';
import { DisableControlDirective } from './disable-control/disable-control.directive';
import { DomChangeDirective } from './dom-change';
import { EllipsisActiveDirective } from './ellipsis-active/ellipsis-active.directive';
import { FindParentBoundaryDirective, SetParentBoundaryDirective } from './find-parent-boundary';
import { NumberDecimalsDirective } from './number-decimals';
import { HidePaginatorControlDirective } from './remove-paginator/remove-paginator-control.directive';
import { WinuiSelectFixDirective } from './winui-select-fix/winui-select-fix.directive';
import { WinuiSelectOptionFixDirective } from './winui-select-fix/winui-select-option-fix.directive';
import { WizardHideStepIconDirective } from './wizard-hide-step-icon/wizard-hide-step-icon.directive';

@NgModule({
    declarations: [
        HidePaginatorControlDirective,
        NumberDecimalsDirective,
        DebounceKeyUpDirective,
        EllipsisActiveDirective,
        DisableControlDirective,
        WizardHideStepIconDirective,
        WinuiSelectFixDirective,
        WinuiSelectOptionFixDirective,
        DomChangeDirective,
        AutoFocusDirective,
        FindParentBoundaryDirective,
        SetParentBoundaryDirective,
    ],
    imports: [TwcModule],
    exports: [
        HidePaginatorControlDirective,
        NumberDecimalsDirective,
        DebounceKeyUpDirective,
        EllipsisActiveDirective,
        DisableControlDirective,
        WizardHideStepIconDirective,
        WinuiSelectFixDirective,
        WinuiSelectOptionFixDirective,
        DomChangeDirective,
        AutoFocusDirective,
        FindParentBoundaryDirective,
        SetParentBoundaryDirective,
    ],
})
export class DirectivesModule {}
